import { PromiseBuilder__Delay_62FBFDE1, PromiseBuilder__Run_212F1D4B } from "../../fable_modules/Fable.Promise.3.1.3/Promise.fs.js";
import { S3_bodyToString, S3_bodyToBlob, S3_GetObjectRequestParams_get_create, S3_GetObjectRequestParams } from "../../bindings/Aws/Fable.Helpers.Aws.js";
import { promise } from "../../fable_modules/Fable.Promise.3.1.3/PromiseImpl.fs.js";
import { map as map_2, defaultArgWith, some, value as value_1 } from "../../fable_modules/fable-library.3.7.12/Option.js";
import { uncurry, stringHash, comparePrimitives, createAtom } from "../../fable_modules/fable-library.3.7.12/Util.js";
import { FSharpMap__Add, tryFind, ofSeq } from "../../fable_modules/fable-library.3.7.12/Map.js";
import { tryFind as tryFind_1, sortBy, reverse, indexed, length, cons, fold, isEmpty, item, updateAt, empty, ofArray, map as map_3 } from "../../fable_modules/fable-library.3.7.12/List.js";
import { join, replace, split } from "../../fable_modules/fable-library.3.7.12/String.js";
import { List_groupBy, List_distinct } from "../../fable_modules/fable-library.3.7.12/Seq2.js";
import { take } from "../../fable_modules/fable-library.3.7.12/Array.js";
import { FlaggedImageListItem, AnatomicalRegionIntrimType, FileMetadata, FrameFile } from "./HistoricalCommon.js";
import { singleton } from "../../fable_modules/fable-library.3.7.12/AsyncBuilder.js";
import { securedApi } from "../../Api.js";
import { AnatomicalRegionViewModel } from "../../Optiscan.Models/View/AnatomicalRegion.js";
import { FSharpResult$2 } from "../../fable_modules/fable-library.3.7.12/Choice.js";

export function customEvent(etype, detail) {
    const eventInit = new (class {
        set bubbles(_arg1) {
        }
        get bubbles() {
            return false;
        }
        set cancelable(_arg2) {
        }
        get cancelable() {
            return false;
        }
        set composed(_arg3) {
        }
        get composed() {
            return false;
        }
        set detail(_arg4) {
        }
        get detail() {
            return detail;
        }
    }
    )();
    const evt = new CustomEvent(etype, eventInit);
    window.dispatchEvent(evt);
}

export function S3_downloadBlobFromS3(s3Ctx, s3Key, onBlobRetrieved, onError) {
    return PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
        const requestParams = new S3_GetObjectRequestParams(s3Ctx.S3Config.Bucket, s3Key);
        const request = S3_GetObjectRequestParams_get_create()(requestParams);
        return s3Ctx.S3Client.getObject(request).promise().then((_arg1) => {
            const matchValue = _arg1.Body;
            if (matchValue == null) {
                onError(s3Key);
                return (Promise.reject(new Error(`Failed to load file ${s3Key}`)));
            }
            else {
                const body = value_1(matchValue);
                return S3_bodyToBlob(body).then((_arg2) => {
                    const blob = _arg2;
                    onBlobRetrieved(blob);
                    return Promise.resolve(blob);
                });
            }
        });
    }));
}

export let Dicoms_dicomCache = createAtom(ofSeq([], {
    Compare: comparePrimitives,
}));

export function Dicoms_clearDicomCache() {
    Dicoms_dicomCache(ofSeq([], {
        Compare: comparePrimitives,
    }), true);
}

export function Dicoms_loadDicomFromS3(s3Ctx, s3Key) {
    const matchValue = tryFind(s3Key, Dicoms_dicomCache());
    if (matchValue == null) {
        return S3_downloadBlobFromS3(s3Ctx, s3Key, (blob_1) => {
            Dicoms_dicomCache(FSharpMap__Add(Dicoms_dicomCache(), s3Key, blob_1), true);
        }, (s3Key_1) => {
            console.error(some(`Failed to load DICOM file ${s3Key_1}`));
        });
    }
    else {
        const a = matchValue;
        return Promise.resolve(a);
    }
}

export function Dicoms_loadAndParseFileList(patientId, sessionId, s3Ctx) {
    return PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
        const requestParams = new S3_GetObjectRequestParams(s3Ctx.S3Config.Bucket, `${patientId}/${sessionId}/.listing`);
        const request = S3_GetObjectRequestParams_get_create()(requestParams);
        return s3Ctx.S3Client.getObject(request).promise().then((_arg1) => (defaultArgWith(map_2(S3_bodyToString, _arg1.Body), () => (Promise.reject(new Error("Failed to get historical file listing")))).then((_arg2) => {
            const allFilesSplit = map_3((fpath) => split(fpath, ["/"], null, 0), ofArray(split(replace(_arg2, "\\", "/"), ["\n"], null, 0)));
            const allStreamPathNames = List_distinct(map_3((fpath_1) => join("/", take(fpath_1.length - 1, fpath_1)), allFilesSplit), {
                Equals: (x, y) => (x === y),
                GetHashCode: stringHash,
            });
            const allFrameFilePaths = map_3((arg) => map_3((pathComponents) => (new FrameFile(join("/", pathComponents), false)), arg[1]), List_groupBy((fpath_2) => join("/", take(fpath_2.length - 1, fpath_2)), allFilesSplit, {
                Equals: (x_1, y_1) => (x_1 === y_1),
                GetHashCode: stringHash,
            }));
            return Promise.resolve(new FileMetadata(allStreamPathNames, allFrameFilePaths, empty(), empty(), sessionId));
        })));
    }));
}

export function Thumbnails_loadThumbnailFromS3(s3Ctx, fpath) {
    return PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
        const requestParams = new S3_GetObjectRequestParams(s3Ctx.S3Config.Bucket, fpath);
        const request = S3_GetObjectRequestParams_get_create()(requestParams);
        return s3Ctx.S3Client.getObject(request).promise().then((_arg1) => {
            const matchValue = _arg1.Body;
            if (matchValue == null) {
                console.error(some(`Failed to load thumbnail ${fpath}`));
                return Promise.resolve(void 0);
            }
            else {
                const body = value_1(matchValue);
                return S3_bodyToBlob(body).then((_arg2) => (Promise.resolve(window.URL.createObjectURL(_arg2))));
            }
        });
    }));
}

export function FlaggedImages_flagFrame(flagged, frames, streamPathIndex, frameIndex) {
    return updateAt(streamPathIndex, updateAt(frameIndex, new FrameFile(item(frameIndex, item(streamPathIndex, frames)).filePath, flagged), item(streamPathIndex, frames)), frames);
}

export function FlaggedImages_loadFlaggedImagesPromise(sessionId, metadata, token) {
    return singleton.Delay(() => singleton.Bind(securedApi(token).getAllAnatomicalRegions(sessionId), (_arg1) => singleton.Bind(securedApi(token).getAllFlaggedSessionImages(sessionId), (_arg2) => {
        const matchValue = [_arg1, _arg2];
        let pattern_matching_result, flaggedImages, sequences, e;
        const copyOfStruct = matchValue[0];
        if (copyOfStruct.tag === 1) {
            pattern_matching_result = 1;
            e = copyOfStruct.fields[0];
        }
        else {
            const copyOfStruct_1 = matchValue[1];
            if (copyOfStruct_1.tag === 1) {
                pattern_matching_result = 1;
                e = copyOfStruct_1.fields[0];
            }
            else {
                pattern_matching_result = 0;
                flaggedImages = copyOfStruct_1.fields[0];
                sequences = copyOfStruct.fields[0];
            }
        }
        switch (pattern_matching_result) {
            case 0: {
                const frameToSequenceMap = isEmpty(sequences) ? fold(uncurry(2, (tupledArg_1) => {
                    const count = tupledArg_1[1] | 0;
                    return (frameCount) => [cons(new AnatomicalRegionViewModel(sessionId, count, frameCount.streamPath), tupledArg_1[0]), count + frameCount.frameCount];
                }), [empty(), 0], map_3((tupledArg) => (new AnatomicalRegionIntrimType(length(tupledArg[1]), item(tupledArg[0], metadata.streamPaths))), indexed(metadata.frames)))[0] : reverse(sortBy((s) => s.frameNumber, sequences, {
                    Compare: comparePrimitives,
                }));
                const newMeta = fold((metadata_1, image) => {
                    const maybeImageSequence = tryFind_1((seq) => (seq.frameNumber <= image.frameNumber), frameToSequenceMap);
                    if (maybeImageSequence == null) {
                        return metadata_1;
                    }
                    else {
                        const imageSequence = maybeImageSequence;
                        const frameIndex = (image.frameNumber - imageSequence.frameNumber) | 0;
                        const maybeLocationIndex = map_2((tuple_2) => tuple_2[0], tryFind_1((arg) => (imageSequence.streamPath === arg[1]), indexed(metadata_1.streamPaths)));
                        if (maybeLocationIndex != null) {
                            const streamPathIndex = maybeLocationIndex | 0;
                            if ((length(item(streamPathIndex, metadata_1.frames)) > frameIndex) && (frameIndex >= 0)) {
                                return new FileMetadata(metadata_1.streamPaths, FlaggedImages_flagFrame(true, metadata_1.frames, streamPathIndex, frameIndex), cons(new FlaggedImageListItem(metadata_1.sessionId, streamPathIndex, frameIndex, imageSequence.streamPath), metadata_1.flaggedImages), metadata_1.frameToSequenceMap, metadata_1.sessionId);
                            }
                            else {
                                return metadata_1;
                            }
                        }
                        else {
                            return metadata_1;
                        }
                    }
                }, metadata, flaggedImages);
                return singleton.Return(new FSharpResult$2(0, new FileMetadata(newMeta.streamPaths, newMeta.frames, newMeta.flaggedImages, frameToSequenceMap, newMeta.sessionId)));
            }
            case 1: {
                return singleton.Return(new FSharpResult$2(1, e));
            }
        }
    })));
}

export function FlaggedImages_mkFlaggedImageListItemFromSelected(metadata, selectedSequence, frameIndex) {
    return new FlaggedImageListItem(selectedSequence.sessionId, selectedSequence.streamPathIndex, frameIndex, item(selectedSequence.streamPathIndex, metadata.streamPaths));
}

export function FlaggedImages_tryGetFrameNumber(metadata, flaggedImage, frameIndex) {
    return map_2((map_1) => (map_1.frameNumber + frameIndex), tryFind_1((map) => (map.streamPath === flaggedImage.streamPath), metadata.frameToSequenceMap));
}

